import {
  SourceStatusDisplayName,
  SourceStatusEnum,
} from "pmt-types/src/enums/SourceStatus.ts";
import { FirstNamedInsured } from "pmt-types/src/models/FirstNamedInsured.ts";
import { Source } from "pmt-types/src/models/Source.ts";
import { useNavigate } from "react-router-dom";
import SearchPage from "../../components/search/searchPage.tsx";
import formatDateString from "../../utils/formatDateString.ts";

export default function SourcesList() {
  const navigate = useNavigate();

  return (
    <SearchPage<Source>
      route="sources"
      allowEntityCreate={true}
      createButtonLabel={"New Source"}
      resultsColumnDef={[
        {
          accessorKey: "name",
          id: "name",
          cell: (info) => info.getValue(),
          header: "Source",
          minSize: 400,
        },
        {
          accessorKey: "status",
          id: "status",
          cell: (info) =>
            SourceStatusDisplayName[info.getValue() as SourceStatusEnum],
          header: "Status",
          minSize: 100,
        },
        {
          accessorKey: "firstNamedInsureds",
          id: "firstNamedInsureds",
          cell: (info) => (info.getValue() as FirstNamedInsured[])?.at(0),
          header: "FNI",
        },
        {
          accessorKey: "updatedDate",
          id: "updatedDate",
          cell: (info) => formatDateString(info.getValue() as string),
          header: "Last Updated",
        },
        {
          id: "view",
          cell: (info) => (
            <div className="flex items-center justify-around mr-4">
              <a
                className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
                onClick={() => {
                  navigate(`/sources/${info.row.original.id}/details`);
                }}
              >
                View
              </a>
              <a
                className="ml-2 text-sm font-medium text-sky-500 hover:text-sky-700 cursor-pointer"
                onClick={() => {
                  navigate(`/sources/${info.row.original.id}?return=search`);
                }}
              >
                Edit
              </a>
            </div>
          ),
          header: "",
          maxSize: 100,
        },
      ]}
    />
  );
}
